import styles from './logo.module.scss';

export default function Logo(props) {
  return (
    <div className={styles.logo} {...props}>
      <img src="/daba-logo.png" alt="daba-logo" />
    </div>
  );
}
